import type { PuzzleClues } from './types.js';

/** Compute clue groups for a single line of boolean cells */
export function cluesFromLine(line: boolean[]): number[] {
  const clues: number[] = [];
  let count = 0;

  for (const cell of line) {
    if (cell) {
      count++;
    } else if (count > 0) {
      clues.push(count);
      count = 0;
    }
  }

  if (count > 0) {
    clues.push(count);
  }

  return clues.length > 0 ? clues : [0];
}

/** Compute row and column clues from a complete boolean grid */
export function cluesFromGrid(grid: boolean[][]): PuzzleClues {
  const rows = grid.map((row) => cluesFromLine(row));

  const numCols = grid.length > 0 ? grid[0].length : 0;
  const cols: number[][] = [];
  for (let c = 0; c < numCols; c++) {
    const column = grid.map((row) => row[c]);
    cols.push(cluesFromLine(column));
  }

  return { rows, cols };
}
